import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseButtonSizeEnum } from '../base-button/base-button-size.enum';
import { MemberRelationshipStatus } from '../../../../models/users/dto/member-relationship-status';

@Component({
  selector: 'app-member-relationship-status-details',
  templateUrl: './member-relationship-status-details.component.html',
  styleUrls: ['./member-relationship-status-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberRelationshipStatusDetailsComponent {
  @Input() relationshipStatus!: MemberRelationshipStatus;
  @Input() disabled = false;
  @Output() editClicked = new EventEmitter<void>();

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
